import classNames from 'classnames';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { CSSProperties } from 'styled-components';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';

import common from './assets/common.png';
import limited from './assets/limited.png';
import rare from './assets/rare.png';
import super_rare from './assets/super_rare.png';
import unique from './assets/unique.png';

const bgs: Record<string, string> = {
  [Rarity.common]: common,
  [Rarity.limited]: limited,
  [Rarity.rare]: rare,
  [Rarity.super_rare]: super_rare,
  [Rarity.unique]: unique,
};

const Root = styled(Vertical).attrs({ center: true, gap: 2 })`
  --border-color: var(--c-nd-900-opaque);

  position: relative;
  isolation: isolate;
  border-radius: var(--double-and-a-half-unit);
  padding: var(--double-unit) var(--double-unit) calc(6 * var(--unit));
  overflow: hidden;
  border: 2px solid var(--border-color);
  width: 100%;
  height: 100%;
`;
const Background = styled.div`
  --bg-asset: linear-gradient(to right, black, black);

  position: absolute;
  z-index: -1;
  inset: 0;
  background:
    linear-gradient(to bottom, transparent, var(--c-black)),
    center / cover var(--bg-asset);
  filter: blur(3px);
`;
const LeagueHeader = styled.img`
  width: 100%;
  max-height: calc(5 * var(--unit));
  position: absolute;
  bottom: 0;
  left: 0;
`;

type Props = {
  picture?: ReactNode;
  body?: ReactNode;
  leaguePictureUrl?: string;
  rarity?: string;
  onReveal?: () => void;
  revealed?: boolean;
};
export const RewardBase = ({
  picture,
  body,
  leaguePictureUrl,
  rarity = 'common',
  onReveal,
  revealed,
}: Props) => {
  const bgAsset = bgs[rarity];

  return (
    <Root
      className={classNames({ revealed })}
      as={onReveal ? 'button' : 'div'}
      onClick={onReveal}
    >
      {bgAsset && (
        <Background
          style={
            bgAsset
              ? ({ '--bg-asset': `url(${bgAsset})` } as CSSProperties)
              : undefined
          }
        />
      )}
      {picture}
      {!revealed && (
        <Button size="small" color="secondary" asSpan>
          <FormattedMessage
            id="RewardBase.reveal.cta"
            defaultMessage="Tap to reveal!"
          />
        </Button>
      )}
      {body}
      {leaguePictureUrl && <LeagueHeader src={leaguePictureUrl} />}
    </Root>
  );
};
